import isEmpty from 'lodash/isEmpty';



export const getEnvOptions = (policies, envs) => {
  return !isEmpty(policies) ? policies.filter((item) => {
    return envs.some((env) => item.environment.indexOf(env) !== -1);
  }) : [];
};
